export class ECodes {
  static readonly Advert = { noAdvert: "AD1", wrongContact: "AD2", hasbids: "AD3", wrongCustomer: "AD4" }
}
